import Absences from 'src/assets/locales/absences.keys';
import AccrualSummary from 'src/assets/locales/accrualSummary.keys';
import Availability from 'src/assets/locales/availability.keys';
import Calendar from 'src/assets/locales/calendar.keys';
import Departments from 'src/assets/locales/departments.keys';
import Employees from 'src/assets/locales/employees.keys';
import Files from 'src/assets/locales/files.keys';
import Global from 'src/assets/locales/global.keys';
import Menu from 'src/assets/locales/menu.keys';
import MessageCenter from 'src/assets/locales/messageCenter.keys';
import Punches from 'src/assets/locales/punches.keys';
import Settings from 'src/assets/locales/settings.keys';
import ShiftSwaps from 'src/assets/locales/shiftSwaps.keys';
import Timecards from 'src/assets/locales/timecards.keys';
import Timeout from 'src/assets/locales/timeout.keys';
import Timesheets from 'src/assets/locales/timesheets.keys';
import { NestedKeyOf } from 'src/shared/utils';

export type TranslationsType = typeof Absences &
  typeof Availability &
  typeof AccrualSummary &
  typeof Calendar &
  typeof Departments &
  typeof Employees &
  typeof Files &
  typeof Global &
  typeof Menu &
  typeof MessageCenter &
  typeof Punches &
  typeof Settings &
  typeof ShiftSwaps &
  typeof Timecards &
  typeof Timeout &
  typeof Timesheets;

export const translations: TranslationsType = Object.assign(
  {},
  Absences,
  AccrualSummary,
  Availability,
  Calendar,
  Departments,
  Employees,
  Files,
  Global,
  Menu,
  MessageCenter,
  Punches,
  Settings,
  ShiftSwaps,
  Timecards,
  Timeout,
  Timesheets,
);

export type TranslationSubstituteType = string | number | Record<string, any>;

export type TranslationFunction = (
  path: NestedKeyOf<TranslationsType> | number,
  substitute?: TranslationSubstituteType,
) => string;
